var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// providers/openai.ts
var openai_exports = {};
__export(openai_exports, {
  CreateChatCompletionRequest: () => CreateChatCompletionRequest,
  CreateChatCompletionResponse: () => CreateChatCompletionResponse,
  CreateCompletionRequest: () => CreateCompletionRequest,
  CreateCompletionResponse: () => CreateCompletionResponse,
  CreateEditRequest: () => CreateEditRequest,
  CreateEditResponse: () => CreateEditResponse,
  CreateEmbeddingRequest: () => CreateEmbeddingRequest,
  CreateEmbeddingResponse: () => CreateEmbeddingResponse,
  CreateImageRequest: () => CreateImageRequest,
  CreateModerationRequest: () => CreateModerationRequest,
  CreateModerationResponse: () => CreateModerationResponse,
  ImagesResponse: () => ImagesResponse,
  createChatCompletion: () => createChatCompletion,
  createCompletion: () => createCompletion,
  createEdit: () => createEdit,
  createEmbedding: () => createEmbedding,
  createImage: () => createImage,
  createModeration: () => createModeration
});
import {
  CreateChatCompletionRequest,
  CreateChatCompletionResponse,
  CreateCompletionRequest,
  CreateCompletionResponse,
  CreateEditRequest,
  CreateEditResponse,
  CreateEmbeddingRequest,
  CreateEmbeddingResponse,
  CreateImageRequest,
  CreateModerationRequest,
  CreateModerationResponse,
  ImagesResponse
} from "openai";

// deezy/api.ts
import axios from "axios";

// deezy/payouts.ts
var payouts_exports = {};
__export(payouts_exports, {
  getPayoutLightningAddress: () => getPayoutLightningAddress,
  setPayoutLightningAddress: () => setPayoutLightningAddress
});
var payoutLightningAddress;
function getPayoutLightningAddress() {
  return payoutLightningAddress;
}
function setPayoutLightningAddress(lightningAddress) {
  payoutLightningAddress = lightningAddress;
}

// deezy/api.ts
var DEEZY_API = "https://api.deezy.io/v1/webai";
async function sendAndPayRequest(request) {
  request.request_id = window.crypto.randomUUID();
  const payoutLightningAddress2 = getPayoutLightningAddress();
  if (payoutLightningAddress2) {
    request.payout_lightning_address = payoutLightningAddress2;
  }
  try {
    const { data } = await axios.post(DEEZY_API, request);
    return data;
  } catch (err) {
    if (axios.isAxiosError(err) && err && err.response && err.response.headers && err.response.headers) {
      console.log(err.response.headers);
      console.log(`Expecting 402 here`);
      const bolt11Invoice = err.response.headers["bolt11-auth"];
      console.log(bolt11Invoice);
      console.log("Sending payment");
      await window.webln.enable();
      await window.webln.sendPayment(bolt11Invoice);
      const { data } = await axios.post(DEEZY_API, request, {
        headers: { "bolt11-auth": bolt11Invoice }
      });
      console.log(data);
      return data;
    }
    throw err;
  }
}

// providers/openai.ts
async function createChatCompletion(data) {
  const resp = await sendAndPayRequest({
    provider: "openai",
    api_path: "v1/chat/completions",
    data
  });
  return resp;
}
async function createEdit(data) {
  const resp = await sendAndPayRequest({
    provider: "openai",
    api_path: "v1/edits",
    data
  });
  return resp;
}
async function createCompletion(data) {
  const resp = await sendAndPayRequest({
    provider: "openai",
    api_path: "v1/completions",
    data
  });
  return resp;
}
async function createImage(data) {
  const resp = await sendAndPayRequest({
    provider: "openai",
    api_path: "v1/images/generations",
    data
  });
  return resp;
}
async function createEmbedding(data) {
  const resp = await sendAndPayRequest({
    provider: "openai",
    api_path: "v1/embeddings",
    data
  });
  return resp;
}
async function createModeration(data) {
  const resp = await sendAndPayRequest({
    provider: "openai",
    api_path: "v1/moderations",
    data
  });
  return resp;
}
export {
  openai_exports as openai,
  payouts_exports as payouts
};
